var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldHashtag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.05 11.3h3.26V8.05h-1.16c-1.16 0-2.1.94-2.1 2.09v1.16zM10.14 15.95h1.16V12.7H8.05v1.16c0 1.15.94 2.09 2.09 2.09zM13.86 15.95c1.15 0 2.09-.94 2.09-2.09V12.7H12.7v3.25h1.16z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.81 2C4.17 2 2 4.17 2 7.81v8.37C2 19.83 4.17 22 7.81 22h8.37c3.64 0 5.81-2.17 5.81-5.81V7.81C22 4.17 19.83 2 16.19 2H7.81zm6.05 15.35h-3.72c-1.92 0-3.49-1.56-3.49-3.49v-3.72a3.5 3.5 0 0 1 3.49-3.49h3.72c1.92 0 3.49 1.56 3.49 3.49v3.72a3.5 3.5 0 0 1-3.49 3.49z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7 8.05v3.26h3.26v-1.16c-.01-1.16-.95-2.1-2.1-2.1H12.7z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldHashtag);
export default __webpack_public_path__ + "static/media/vuesax-bold-hashtag.8cbe1be4cefef99e6e3ac0ae156ad4bd.svg";
export { ForwardRef as ReactComponent };